import { useField } from 'formik';
import { ProposalFormDataLineItem } from 'types/proposal';
import Typography from '@mui/material/Typography';
import numberWithCommas from 'utils/numberWithCommas';
import { getTotalAmount } from './utils';

export const ProposalFormTotal = () => {
    const [field, ,] = useField<ProposalFormDataLineItem[]>('lineItems');
    return <Typography textAlign="right">Total: ${numberWithCommas(getTotalAmount(field.value), 2)}</Typography>;
};
